// extracted by mini-css-extract-plugin
module.exports = {"mask":"style_mask__KRlIv"};